// Actions
import { showSnackbarMessage } from 'actions/SnackbarActions';

// Helpers
import { apiRequest } from 'helpers/apiClient';

export const initateSigning = (submissionId, accessToken) => () => {
    return apiRequest(`/api/v1/signering/${submissionId}/initiate`, {
        method: 'POST',
        accessToken,
        headers: { 'Content-Type': 'application/json' }
    }).then(result => {
        return result.ok
            ? { status: result.status, data: result.data }
            : { status: result.status, xCorrelationId: result.xCorrelationId };
    });
}


const getFilenameFromContentDisposition = contentDisposition => {
    const regex = new RegExp(`filename=(.*?);`, 'gm')
    return regex.exec(contentDisposition)?.[1] || null;
}

export const getSignedDocument = (submissionId, accessToken) => dispatch => {
    return apiRequest(`/api/v1/signering/${submissionId}/signed-document`, {
        accessToken,
        parse: 'blob',
        parseErrorBody: false
    }).then(async result => {
        const contentDisposition = result.response?.headers?.get?.('Content-Disposition');
        const filename = getFilenameFromContentDisposition(contentDisposition) || 'skjema.pdf';
        // Ved ok gir klienten blob i data; ellers hent blob direkte fra responsen (behold gammel adferd).
        const blob = result.data !== undefined ? result.data : await result.response?.blob?.();
        return {
            filename,
            blob
        };
    });
}


export const removeSigningProcess = (form, accessToken) => dispatch => {
    dispatch(showSnackbarMessage('Fjerner signeringsjobb', 3000))
    return apiRequest(form._links?.signering?.href, {
        method: 'DELETE',
        accessToken
    }).then(() => {
        dispatch(showSnackbarMessage('Signeringsjobb er fjernet', 3000));
    });
}
